import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import Vant from "vant";
import "vant/lib/index.css";
import "./utils/rem";

Vue.prototype.axios = axios;
axios.defaults.baseURL = "https://bidtest.zbfit.com/api/";
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  }
);
Vue.prototype.getQueryValue = function (name) {
  var url = window.location.href;
  var result = url.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
  if (result == null || result.length < 1) {
    return "";
  }
  return decodeURI(result[1]);
};
Vue.use(Vant);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
